import Settings from './Settings';

import Meta from "../../components/Meta";
import Header from "../../components/Header";

function Template() {
	return (
		<>
			<Meta title="Settings" />
			<Header heading={"Settings"} />
			<main>
				<Settings />
			</main>
		</>
	)
}

export default {
	Template,
	Settings
};
